import { useAuth0 } from '@auth0/auth0-react'
import { useCallback, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import AgenciesControl from '../components/agencies/AgenciesDropdown.js'
import { currentAdminPropTypes } from '../reducers/adminsReducer'
import { currentAgencyPropTypes } from '../reducers/currentReducer.js'
import { universalLogout } from '../redux/storeConfig/slices/slice.auth/auth.thunks'
import { routePropTypes } from '../routes'

const modalStyle = {
  maxWidth: '500px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'block',
  maxHeight: '100%',
  marginRight: 'auto',
  marginLeft: 'auto'
}
/**
 *
 * @param {Object} props
 * @param {import('../routes.js').Route} props.route
 * @param {import('../reducers/adminsReducer.js').CurrentAdmin} props.currentAdmin
 * @param {import('../reducers/currentReducer.js').CurrentAgency} props.currentAgency
 *
 * @returns {JSX.Element}
 */
function ProtectedRouteComponent({ route, currentAdmin, currentAgency, ...props }) {
  const { component: Component, path, orgLevel } = route
  const { logout, isAuthenticated } = useAuth0()

  const dispatch = useDispatch()
  const isAgencyContext = Boolean(currentAgency?.id)

  const handleAdminLevel = useCallback(() => {
    if (orgLevel && isAgencyContext) {
      console.info(`Attempting to access Organization route as Agency. Redirecting...`)
    }

    if (!orgLevel && currentAdmin.logged_in_as === 'Organization' && !isAgencyContext) {
      console.info(`Attempting to access Agency route as Organization. Redirecting...`)
    }
  }, [currentAdmin.logged_in_as, isAgencyContext, orgLevel])

  useEffect(() => {
    handleAdminLevel()
  }, [handleAdminLevel])

  if (
    (orgLevel && isAgencyContext) ||
    (!orgLevel && currentAdmin.logged_in_as === 'Organization' && !isAgencyContext && path !== '/dashboard') // Prevent loop
  )
    return <Redirect to="/dashboard" />

  return (
    <>
      <Component {...props} />
      <Modal
        isOpen={currentAgency?.maintenance_mode && currentAdmin.organization_admins.length === 0}
        style={modalStyle}
      >
        <ModalHeader>{currentAgency?.name} is in maintenance mode</ModalHeader>
        <ModalBody>
          <AgenciesControl>
            <div className="d-flex justify-content-between align-items-center">
              <AgenciesControl.Dropdown style={{ width: '60%' }} />
              <AgenciesControl.LogoutButton />
            </div>
          </AgenciesControl>
        </ModalBody>
        <ModalFooter>
          <Button
            color="link"
            onClick={async () => {
              if (isAuthenticated)
                await logout({
                  logoutParams: { returnTo: `${window.location.origin}/login` }
                })
              await dispatch(universalLogout())
            }}
          >
            Sign out
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

ProtectedRouteComponent.propTypes = {
  route: routePropTypes,
  currentAdmin: currentAdminPropTypes,
  currentAgency: currentAgencyPropTypes
}

export default connect(state => ({
  currentAdmin: state.admins.current_admin,
  currentAgency: state.current.agency
}))(ProtectedRouteComponent)
